import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SuggestedMyLeaderGroupsLoadFulfilledAction } from '../../domains/suggestedMyLeaderGroups/actions.types';

import { SuggestedMyLeaderGroups } from './types';

export const initialState: SuggestedMyLeaderGroups = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type SuggestedMyLeaderGroupsAction = SuggestedMyLeaderGroupsLoadFulfilledAction;

const reducer: Reducer<SuggestedMyLeaderGroups, SuggestedMyLeaderGroupsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_MY_LEADER_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.suggestedMyLeaderGroups);
    default:
      return state;
  }
};

export default reducer;
